
import { Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, bool_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { GoalStatus_$reflection } from "./Challenge.js";
import { op_Multiply, toInt64 } from "../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { toDecimal } from "../fable_modules/fable-library-js.5.3.0/BigInt.js";
import { map } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { TrancheResult } from "./FeeShare.js";

/**
 * The host's qualifying state at the moment of evaluation.
 */
export class EvaluationInputs extends Record {
    constructor(HasDailyLog, HasQualifyingPledge, GoalStatus) {
        super();
        this.HasDailyLog = HasDailyLog;
        this.HasQualifyingPledge = HasQualifyingPledge;
        this.GoalStatus = GoalStatus;
    }
}

export function EvaluationInputs_$reflection() {
    return record_type("Shared.EvaluationInputs", [], EvaluationInputs, () => [["HasDailyLog", bool_type], ["HasQualifyingPledge", bool_type], ["GoalStatus", GoalStatus_$reflection()]]);
}

/**
 * The cents a tranche releases from a fee. Truncating the decimal product floors it for
 * non-negative values, so summed tranche amounts can never exceed the fee.
 */
export function FeeShare_trancheAmountCents(feeCents, percentage) {
    return toInt64(op_Multiply(toDecimal(feeCents), percentage));
}

function FeeShare_isEarned(inputs, condition) {
    switch (condition.tag) {
        case 1:
            return inputs.HasQualifyingPledge;
        case 2: {
            const matchValue = inputs.GoalStatus;
            switch (matchValue.tag) {
                case 0:
                    return false;
                default:
                    return true;
            }
        }
        default:
            return inputs.HasDailyLog;
    }
}

/**
 * Evaluate a fee-share schedule against the host's qualifying state.
 * feeCents is the fee actually collected (from ChallengeFeePaid), never a fee-table literal,
 * so a future price change cannot retroactively misstate historical accruals.
 * Pure: no clock, no IO.
 */
export function FeeShare_evaluate(schedule, inputs, feeCents) {
    return map((tranche) => {
        const earned = FeeShare_isEarned(inputs, tranche.Condition);
        return new TrancheResult(tranche.Condition, tranche.Percentage, earned, earned ? FeeShare_trancheAmountCents(feeCents, tranche.Percentage) : (0n));
    }, schedule.Tranches);
}

//# sourceMappingURL=FeeShareEvaluator.js.map
